import React from 'react'
import { Block, Field, LabeledInput, LocalizedText, Logo, SubmitButton, FormContext } from 'labguard-cdk'
import { IdCardIcon, KeyIcon, SignInAltIcon } from 'src/components/common'
import DatabaseSelector from './DatabaseSelector'
import styles from './LoginForm.scss'

const LoginForm = () => {
  const form = FormContext.use()
  return (
    <Block as="form" className={styles.loginForm}>
      <Logo className={styles.logo} />
      <Field
        type="text"
        name="username"
        component={LabeledInput}
        icon={IdCardIcon}
        topLabel={<LocalizedText id="WEB_LOGIN_ID" />}
      />
      <Field
        type="password"
        name="password"
        component={LabeledInput}
        icon={KeyIcon}
        topLabel={<LocalizedText id="WEB_LOGIN_PASSWORD" />}
      />
      <DatabaseSelector />
      <SubmitButton icon={SignInAltIcon} className={styles.submit}>
        <LocalizedText id="WEB_LOGIN" />
      </SubmitButton>
      <input type="submit" onClick={form.submit} className={styles.hidden} />
    </Block>
  )
}

export default LoginForm
